import { IRLCharDataElementScope } from "../../ts/rlAdmin.models";
import * as Utils from "../../ts/rlAdmin.utils";
import { DateLocaleService } from "../../services/date-locale-service";

export function RLDataEditMultiDate() {

    var directive: ng.IDirective = {
        restrict: "A",
        template: require("/assets/app/templates/chardata/charData-edit-multi-date.html"),
        require: "rlDataEditMultiDate",
        controller: RLDataEditMultiDateController,
        controllerAs: "emdVM",
        link: (scope: IRLCharDataElementScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: RLDataEditMultiDateController) => {

            var perpDiv = $(".has-perpetuity", element);
            var valueDiv = $(".has-date", element);

            scope.$watch(() => controller.perpetuity,
                (newValue, oldValue) => {
                    if (newValue) {
                        perpDiv.show();
                        valueDiv.hide();
                    } else {
                        perpDiv.hide();
                        valueDiv.show();
                    }
                });

            var newInput = element.find("input[data-newvalue]").eq(0);
            if (newInput != null) {
                newInput.bind("blur", () => {
                    controller.Add();
                });
            }
        }
    };
    return directive;
}

class RLDataEditMultiDateController {
    static $inject = ["$scope", "dateLocaleService"];

    lastValue: string;
    perpetuity: boolean;
    offerPerpetuity: boolean;
    editedDateValue: string;

    // holds value for new value box
    newValue: string;

    constructor(private $scope: IRLCharDataElementScope, private dateLocaleService: DateLocaleService) {

        var dateRegex = /(\d{1,2}[\/\.\-]\d{1,2}[\/\.\-]\d{4})|(\d{4}[\/\.\-]\d{1,2}[\/\.\-]\d{1,2})/;

        // only show for tagLabels like *_end
        this.offerPerpetuity = $scope.cmd.tagLabel.indexOf("_end") >= 0;
        var format = "L";
        var isPerpetuity = (value: string): boolean => {
            if (value != "") {
                var date = dateLocaleService.parseStorageMoment(value);
                return this.offerPerpetuity && Utils.DateUtil.IsPerpetuity(date);
            }
            return false;
        };

        $scope.$watch(() => $scope.firstCharData,
            (newValue, oldValue) => {
                if (newValue != null) {
                    if (dateRegex.test(newValue.value)) {
                        this.perpetuity = isPerpetuity(newValue.value);
                        var dateMoment = dateLocaleService.parseStorageMoment(newValue.value);
                        dateMoment = dateLocaleService.localizeMoment(dateMoment);
                        var localeDateString = dateMoment.format("L");
                        if (dateMoment.isValid() && this.editedDateValue != localeDateString) {
                            this.editedDateValue = localeDateString;
                        }
                    } else if (this.editedDateValue != newValue.value) {
                        this.editedDateValue = newValue.value;
                    }
                }
            }, true);

        $scope.$watch(() => this.editedDateValue,
            (newValue, oldValue) => {
                if (newValue != null) {
                    if (dateRegex.test(newValue)) {
                        var dateMoment = dateLocaleService.parseMoment(newValue);
                        if (dateMoment.isValid()) {
                            dateMoment = dateLocaleService.delocalizeMoment(dateMoment);
                            var storageDateString = dateMoment.format("L");
                            if (this.$scope.firstCharData.value != storageDateString) {
                                this.$scope.firstCharData.value = storageDateString;
                            }
                        }
                    }
                    else if (this.$scope.firstCharData.value != newValue) {
                        this.$scope.firstCharData.value = newValue;
                    }
                }
            }, true);

        $scope.$on('requestViewAlerts', function (e) {
            $scope.$broadcast('executeViewAlerts');
        });

        $scope.$on('requestNewAlert', function (e) {
            $scope.$broadcast('executeNewAlert');
        });

        $scope.$on('requestAlertsRefresh', function (e) {
            $scope.$broadcast('executeAlertsRefresh');
        });
    }

    PerpetuityChecked() {
        if (this.perpetuity) {
            this.lastValue = this.$scope.firstCharData.value;
            this.$scope.firstCharData.value = "09/09/9999";
        } else {
            this.$scope.firstCharData.value = this.lastValue;
        }
    }

    // add a new value to the list
    Add() {
        if (!_.isEmpty(this.newValue)) {
            // add new value w/ artificial hash for uniqueness
            this.$scope.charDatas.push({ _hash: _.random(10000), charID: this.$scope.cmd.characteristicID, recCharID: 0, value: this.newValue, valueID: null });
            // blank out new value input box
            this.newValue = "";
        }
    }

    // remove a value from the list
    Remove(value) {
        _.remove(this.$scope.charDatas, (char) => { return char == value; });
    }

    CaptureKeysUp(event: JQueryEventObject) {
        if (event.keyCode == 13) {
            event.preventDefault();
            this.Add();
        }
    }

    CaptureKeysDown(event: JQueryEventObject) {
        if (event.keyCode == 9) {
            if (!_.isEmpty(this.newValue)) {
                event.preventDefault();
                this.Add();
            }
        }
    }
}

/* directive for multi-date display element */
export function RLDataDisplayMultiDate() {
    var directive: ng.IDirective = {
        restrict: "A",
        template: require("/assets/app/templates/chardata/charData-display-multi-date.html"),
        controller: RLDataDisplayMultiDateController,
        controllerAs: "dmdVM"
    };
    return directive;
}

class RLDataDisplayMultiDateController {
    static $inject = ["$scope", "dateLocaleService"];

    displayValue: string;
    constructor(private $scope: IRLCharDataElementScope, private dateLocaleService: DateLocaleService) {

        var getDisplayValue = (value: string): string => {
            var dateMoment = dateLocaleService.parseStorageMoment(value);
            if (dateMoment.isValid()) {
                if (Utils.DateUtil.IsPerpetuity(dateMoment)) {
                    return "Perpetuity";
                } else {
                    dateMoment = dateLocaleService.localizeMoment(dateMoment);
                    return dateMoment.format("L");
                }
            }
            return "";
        };

        $scope.$watch<string>("firstCharData.value", (newValue, oldValue) => {
            this.displayValue = getDisplayValue(newValue);
        });
    }
}
